<template>
  <div
    v-on:click="redirect"
    class="py-3 flex w-full"
    :class="{ 'border-b': show_border }"
  >
    <div class="flex w-full items-center">
      <div
        v-if="icon"
        class="w-icon h-icon mr-2 flex-shrink-0 flex items-center"
      >
        <img :src="require('@/assets/icons/' + icon)" />
      </div>

      <div class="flex-grow flex flex-col w-full">
        <div class="flex items-center justify-between w-full min-w-0">
          <div
            class="text-md font-semibold pr-2 break-words whitespace-normal min-w-0"
          >
            {{ title }}
          </div>

          <div
            class="flex items-center justify-end flex-1 min-w-0 overflow-hidden"
          >
            <span
              v-if="!$slots.default"
              style="
                display: block;
                width: 150px;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                text-align: right;
              "
            >
              {{ value }}
            </span>

            <slot></slot>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "v-setting-card-item",
  props: {
    title: {
      type: String,
    },
    value: {
      type: String,
      default: "",
    },
    icon: {
      type: String,
      default: "",
    },
    href: {
      type: String,
    },
    show_border: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    redirect() {
      if (this.href != null) {
        this.$router.push(this.href);
      }
    },
  },
};
</script>

<style scoped>
.truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
